import { InputNumber } from "../../../../../../../components/InputNumber/InputNumber.tsx";
import { SETTINGS_ITEM_WIDTH } from "../../constants.ts";

// XXX: The fontSize is in pixels, so we need to convert the charSpacing (thousands of em units) to pixels and vice versa.
// 1em = fontSize in pixels, so 1000 charSpacing units = fontSize pixels
const pixelsToLineHeight = (pixels: number, fontSize: number): number =>
  pixels / fontSize;

const lineHeightToPixels = (lineHeight: number, fontSize: number): number =>
  lineHeight * fontSize;

export const LineHeightSlider = ({
  lineHeight,
  fontSize,
  onLineHeightChange,
}: {
  lineHeight: number;
  fontSize: number;
  onLineHeightChange: (lineHeight: number) => void;
}) => {
  const pixelValue = Math.round(lineHeightToPixels(lineHeight, fontSize));

  const handlePixelChange = (pixels: number) => {
    const newLineHeight = pixelsToLineHeight(pixels, fontSize);
    onLineHeightChange(newLineHeight);
  };

  const minValue = Math.round(lineHeightToPixels(0.5, fontSize));
  const maxValue = Math.round(lineHeightToPixels(3, fontSize));

  const onIconDrag = (deltaX: number, pixelRange: number) => {
    const pixelDelta = (deltaX / pixelRange) * (maxValue - minValue);
    const clampedPixelDelta = Math.max(
      minValue,
      Math.min(maxValue, pixelValue + pixelDelta),
    );
    handlePixelChange(clampedPixelDelta);
  };

  return (
    <InputNumber
      min={minValue}
      max={maxValue}
      value={pixelValue}
      onChange={handlePixelChange}
      className={SETTINGS_ITEM_WIDTH}
      suffix="px"
      iconName="AlignVerticalSpaceAround"
      onIconDrag={(deltaX) => onIconDrag(deltaX, 100)}
    />
  );
};
